export default "__VITE_ASSET__BAoQK_KP__"